<template>
    <div class="tablematchadvicer">
    <md-table md-card>
		<md-table-row>
			<md-table-head></md-table-head>
			<md-table-head>Name</md-table-head>
			<md-table-head>Score</md-table-head>
			<md-table-head>Location</md-table-head>
			<md-table-head>Community</md-table-head>
			<md-table-head>Freq</md-table-head>
			<md-table-head>Last Request Received</md-table-head>
			<md-table-head>Last Response</md-table-head>
			<md-table-head></md-table-head>
		</md-table-row>
      <template v-for="(member, index) in advisors" v-if="member._id !== ask.createdByMemberID">
  		<md-table-row :key="member._id" :class="{ opened: opened.includes(member._id) }">
			<md-table-cell>
				<font-awesome-icon class='selector' v-if="selectedAdvisors.indexOf(member._id) < 0" icon="square" @click="toggle(member)" />
				<font-awesome-icon class='selector' v-if="selectedAdvisors.indexOf(member._id) >= 0" icon="check-square" @click="toggle(member)" />
			</md-table-cell>
	        <md-table-cell v-if="member.first && member.last"><span @click='goToProfile(member._id)'>{{ member.first + ' ' +  member.last }}</span></md-table-cell>
	        <md-table-cell v-else><span @click='goToProfile(member._id)'>{{member.emails[0]}}</span></md-table-cell>
	        <md-table-cell>{{ calculate(member.skills)+'%' }}</md-table-cell>
	        <md-table-cell v-if="member.state && member.country">{{ member.state + ', ' + member.country }}</md-table-cell>
	        <md-table-cell v-else>---</md-table-cell>
	        <md-table-cell>{{ ask.community }}</md-table-cell>
	        <md-table-cell v-if="member.frequency">{{ setFrequency(member.frequency) }}</md-table-cell>
	        <md-table-cell v-else>W</md-table-cell>
	        <md-table-cell v-if="$lodash.has(member.request, 'lastRequest')">{{member.request.lastRequest | momentDate}}</md-table-cell>
	        <md-table-cell v-else>---</md-table-cell>
	        <md-table-cell v-if="$lodash.has(member.response, 'lastResponse')">{{member.response.lastResponse | momentDate}}</md-table-cell>
	        <md-table-cell v-else>---</md-table-cell>
	        <md-table-cell>
       		 	<md-button class="md-mini md-fab btnplain" @click="toggle1(member._id)">
       		 		<font-awesome-icon class='selector' v-if="opened.includes(member._id)" icon="caret-up" />
       		 		<font-awesome-icon class='selector' v-else icon="caret-down" />
       		 	</md-button>
	        </md-table-cell>
		</md-table-row>
		<div v-bind:key="'row-'+index" class="table-row" v-if="opened.includes(member._id)">
			<md-table-cell colspan="10">
            	<div class="flex-box">
					<md-chip class="flex-child" v-for="(skill, idx) in member.skills" :key="skill+idx" md-disabled>{{skill}}</md-chip>
				</div>
				<div class="bio1" v-if="member.bio">
					<span class="bio-title1"><strong>Bio</strong></span>
					<p class="md-body-1 light bio-paragraph">{{member.bio}}</p>
				</div>
			</md-table-cell>
		</div>
	</template>
    </md-table>
  </div>
</template>
<!-- Script-->
<script>
import API from "../services/API";
export default {
  name: "MatchedAdvisors",
  props: {
  	advisors: {
  		type: Array,
  		required: true
  	},
  	ask: {
  		type: Object,
  		required: true
  	}
  },
  data() {
  	return {
  		api: new API(),
  		selectedAdvisors: [],
      	opened: [],
      	availableFrequncy: [
    		{'Not available': 'N/A'},
    		{'Once a quarter': 'Q'},
    		{'Once a week': 'W'},
    		{'Once a month': 'M'},
    		{'Daily': 'D'},
    		{'As often as needed': 'A'}
    	]
  	}
  },
  methods: {
    calculate(skills) {
    	var matched = 0;
    	this.ask.tags.forEach((tag, index) => {
    		skills.forEach((skill, i) => {
    			if (tag.toLowerCase() === skill.toLowerCase()) {
    				matched += 1;
    			}
    		})
    	})
    	return parseInt(Math.round(matched / this.ask.tags.length * 100)) || 0;
    },
    toggle: function(member) {
      if (this.selectedAdvisors.indexOf(member._id) >= 0) {
        this.selectedAdvisors.splice(
          this.selectedAdvisors.indexOf(member._id),
          1
        );
      } else {
        this.selectedAdvisors.push(member._id);
      }
      this.$emit("changed", this.selectedAdvisors);
    },
    goToProfile: function(memberID) {
      let route = this.$router.resolve({path: `/members/${memberID}`});
      window.open(route.href, '_blank');
    },
    toggle1(id) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
      	this.opened.splice(index, 1)
      } else {
      	this.opened.push(id)
      }
    },
    setFrequency: function(freq) {
    	var data = '';
    	this.availableFrequncy.filter((obj) => {
    		return Object.keys(obj).some((key) => {
    			if (key.toLowerCase() === freq.toLowerCase()) {
					data = obj[key];
					return false;
				} else {
					if (/once a week/.test(key)) {
						data = obj[key];
						return false;
					}
				}
				return false;
    		})
    	});
    	return data;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/MatchedAdvisors.vue